import React from "react";
import { Card, Icon } from "./rivplay";

/* Grilla de servicios (ícono, nombre y una línea) con las clases cs-services/cs-service del design system.
   Se usa donde no hay capturas que mostrar, como en IAClinical (código y producto privados). */
export function ServiceTiles({ items, className }) {
  return (
    <div className={"cs-services" + (className ? " " + className : "")}>
      {items.map((s) => (
        <Card key={s.name} className="cs-service">
          <span className="cs-service-icon"><Icon name={s.icon} size={18} /></span>
          <strong>{s.name}</strong>
          <span className="rp-body-s">{s.text}</span>
        </Card>
      ))}
    </div>
  );
}
